import SignalR from '@/services/SignalRService'

export const SET_IS_MENU_ACTIVE = 'isMenuActive'

export default {
    authUser (state, authData) {
        state.accessToken = authData.token_type + ' ' + authData.access_token
        state.token = authData.access_token
    },
    signalRListen (state) {
        state.singnalR = SignalR
        // state.singnalR.handleEvents()
        state.singnalR.handleSnapshots()
        state.singnalR.startListen()
    },
    signalRStopEvent (state) {
        state.singnalR = SignalR
        state.singnalR.stopHandleEvents()
    },
    signalRDisconnect (state) {
        state.singnalR.disconnect()
    },
    clearAuth: state => {
        state.accessToken = ''
        state.token = ''
    },
    setDeviceTypes (state, deviceTypes) {
        state.deviceTypes = deviceTypes
    },
    setVehicleTypes (state, vehicleTypes) {
        state.vehicleTypes = vehicleTypes
    },
    setFuelTypes (state, fuelTypes) {
        state.fuelTypes = fuelTypes
    },
    setRoles (state, roles) {
        state.roles = roles
    },
    setEventTypes (state, eventTypes) {
        state.eventTypes = eventTypes
    },
    setVehicleStatuesTypes (state, vehicleStatuesType) {
        state.vehicleStatuesType = vehicleStatuesType
    },
    setSnapshotTypes (state, snapshotTypes) {
        state.snapshotTypes = snapshotTypes
    },
    setDeviceIntegrations (state, deviceIntegrations) {
        state.deviceIntegrations = deviceIntegrations
    },
    setDataToCapture (state, dataToCapture) {
        this.state.dataToCapture = dataToCapture
    },
    setSnapshotId (state, snapshotId) {
        state.snapshotId = snapshotId
    },
    setEventId (state, eventId) {
        state.eventId = eventId
    },
    setEventAlertLevelType (state, eventAlertLevelType) {
        state.eventAlertLevelType = eventAlertLevelType
    },
    setUserName (state, userName) {
        state.userName = userName
    },
    setRequestStatus (state, requestStatus) {
        state.requestStatus = requestStatus
    },
    setRequestType (state, requestType) {
        state.requestType = requestType
    },
    addActiveFleet (state, fleetId) {
        let index = state.mapActiveFleets.indexOf(fleetId)
        if (-1 === index && null != fleetId) {
            state.mapActiveFleets.push(fleetId)
        }
    },
    removeActiveFleet (state, fleetId) {
        let index = state.mapActiveFleets.indexOf(fleetId)

        if (0 <= index) {
            state.mapActiveFleets.splice(index, 1)
        }
    },
    setIsEventPanelActive (state, status) {
        state.isEventPanelActive = status
    },
    setIsMediaPanelActive (state, status) {
        state.isMediaPanelActive = status
    },
    setMapSettings (state, mapSettings) {
        state.mapSettings = mapSettings
    },
    isMenuActive (state, status) {
        state.isMapActive = status
    }
}
